import * as React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";
import { isHerikaPlatform } from "@/auth/keycloak";

interface PlatformGuardProps {
  children: React.ReactNode;
}

/**
 * Restrict /platform/* routes to users with the realm role `herika-platform`
 * (D14 platform role — Henoia only). This is the cross-org area: the
 * feature-flag console and the consolidated multi-tenant views. Distinct from
 * `AdminGuard` (`herika-admin`), which gates the per-company admin UI without
 * any cross-org access.
 *
 * The matching backend bypass lives in the booking-engine `AuthContext.is_platform`.
 */
export function PlatformGuard({ children }: PlatformGuardProps) {
  const { initialized, isAuthenticated } = useAuth();

  if (!initialized) return null;
  if (!isAuthenticated) return <Navigate to="/" replace />;
  if (!isHerikaPlatform()) return <Navigate to="/" replace />;

  return <>{children}</>;
}
